import { render, staticRenderFns } from "./contract-cashback.vue?vue&type=template&id=83a6eebc&scoped=true"
import script from "./contract-cashback.vue?vue&type=script&lang=js"
export * from "./contract-cashback.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=83a6eebc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a6eebc",
  null
  
)

export default component.exports